if(!customElements.get('swym-custom-button')){
    class SwymCustomButton extends HTMLElement{
        constructor(){
            super();
            this._initializeSwymComponent();
        }

        async _init(swat){
            await this._initialiseSelectors(swat);
            this._attachEventListeners(swat);
        }

        async _initialiseSelectors(swat){
            this.swat = swat;
            this.seriesPopup = document.querySelector('#swymcs-user-login-status-popup');
            this.seriesPopupCloseButton = document.querySelector('#swymcs-close-popup');
            this.bindingButtons = document.querySelector('#swymcs-binding-buttons');
            this.languageSelect = document.querySelector('#swymcs-language-select');
            this.wishlistSelector = document.querySelector('#swymcs-wishlist-select');
            this.featuredCollection = document.querySelector('.swymcs-featured-collection');
            this.featuredCollectionProducts = this._getFeaturedCollection();
            this.featuredCollectionProductGroups = await this._getShopifyProductsData(this.featuredCollectionProducts);
            await this._getLists();
        }

        _createList () {
            return new Promise((resolve, reject) => {
                this.swat.createList(
                    { lname: "My Wishlist" },
                    newList => {
                        resolve(newList);
                    },
                    error => {
                        console.log("Error while creating a List", error);
                        reject(error);
                    }
                );
            });
        }

        async _getLists () {
            try {
                const lists = await new Promise((resolve, reject) => {
                    this.swat.fetchLists({
                        callbackFn: resolve,
                        errorFn: reject
                    });
                });
                this.lists = lists;
                this._renderWishlistSelectorOptions(lists);
            } catch (err) {
                console.error("Failed to fetch or create list", err);
                throw err;
            }
        }

        async _renderWishlistSelectorOptions(lists){
            this.wishlistSelector.innerHTML = '';
            if (lists.length) {
                let optionsFragement = document.createDocumentFragment();
                lists.forEach(list => {
                    const option = document.createElement('option');
                    option.value = list.lid;
                    option.textContent = list.lname;
                    optionsFragement.appendChild(option);
                });
                this.wishlistSelector.appendChild(optionsFragement);
                this.activeListId = lists[0].lid;
                return;
            } else {
                const newList = await this._createList();
                this.activeListId = newList.lid;
                return this._renderWishlistSelectorOptions([newList]);
            }
        }

        _getFeaturedCollection(){
            const products = [];
            if (this.featuredCollection) {
                const items = this.featuredCollection.querySelectorAll('li[data-du]');
                items.forEach(item => {
                const du = item.getAttribute('data-du');
                if (du) {
                    products.push({ du });
                }
                });
            }
            return products;
        }

        async _getShopifyProductsData(products) {
            if (!products.length) return [];
            let buggedProductsArray = [];
            const productGroups = [];
            await Promise.all(products.map(async(pdp) => {
                try {
                    const productHandleString = pdp.du.split('/products/')[1];
                    const productHandle = productHandleString.split('?')[0];
                    const reqURL = `https://${window.shopDomain}/products/${productHandle}`;
                    const productData = await fetch(`${reqURL}.js`);
                    const jsonData = await productData.json();
                    jsonData.variants.forEach(v => {
                        const binding = v.option1;
                        const language = v.option2;
                        const entry = {
                            du: pdp.du,
                            empi: jsonData.id,
                            epi: v.id
                        };
                        let group = productGroups.find(g => g.binding === binding && g.language === language);
                        if (!group) {
                            group = {
                                binding,
                                language,
                                items: []
                            };
                            productGroups.push(group);
                        }
                        group.items.push(entry);
                    });
                    return true;
                } catch (error) {
                    const errorObj = {};
                    errorObj[pdp.du] = error;
                    buggedProductsArray.push(errorObj);
                    return null;
                }
            }));
            this.featuredCollectionProductLanguages = [...new Set(productGroups.map(g => g.language))];
            this.featuredCollectionProductBindings = [...new Set(productGroups.map(g => g.binding))];
            let buttonsHtml=``;
            this.featuredCollectionProductBindings.forEach(binding => {
                buttonsHtml+=`
                    <button class="binding-add button button--secondary" data-binding="${binding}">Add All ${binding}</button>
                `
            });
            this.bindingButtons.innerHTML=buttonsHtml;
            buttonsHtml=``;
            this.featuredCollectionProductLanguages.forEach(language => {
                buttonsHtml+=`
                    <option value="${language}">${language}</option>
                `
            });
            this.languageSelect.innerHTML=buttonsHtml;
            this.selectedLanguage = this.languageSelect.value;
            if(buggedProductsArray.length)
                console.log("Bugged Products:", buggedProductsArray);
            return productGroups;
        }

        _showPopupContainer (selector) {
            swat.initializeActionButtons("body");
            selector.classList.remove('swym-hide-container');
            selector.classList.add('swym-active-popup');
            document.body.classList.add('swymcs-no-scroll');
        }

        _hidePopupContainer(selector) {
            selector.classList.add('swym-hide-container');
            selector.classList.remove('swym-active-popup');
            document.body.classList.remove('swymcs-no-scroll');
        }

        _overlayEvent(evt) {
            if (evt.target.nodeName == 'BODY') {
                document.querySelectorAll(".swym-active-popup").forEach(popup => this._hidePopupContainer(popup));
            }
        }

        async _customButtonFunction (evt) {
            this._showPopupContainer(this.seriesPopup);
        }

        async _checkForExistingListsAndRefetchLists(id) {
            !(this.lists.some(list => list.lid === id)) && await this._getLists();
        }

        //Adding Batching Logic
        _batchArray(array, batchSize) {
            const batches = [];
            for (let i = 0; i < array.length; i += batchSize) {
                batches.push(array.slice(i, i + batchSize));
            }
            return batches;
        }

        async _addSeriestoWishlist (evt) {
            const target = evt.target;
            if (target.tagName === 'BUTTON')
            {
                const binding = target.dataset.binding;
                let products = this.featuredCollectionProductGroups.find(
                    p => p.binding === binding && p.language === this.selectedLanguage
                )?.items || [];

                //Filter out products already in the active list
                let currentListProducts = this.lists.find(l => l.lid === this.activeListId)?.listcontents || [];
                let filteredProducts = products.filter(p => 
                    !currentListProducts.some(prod => prod.epi === p.epi)
                );

                //Batch the products
                const batches = this._batchArray(filteredProducts, 10);

                if(products.length){
                    if(!filteredProducts.length){
                        this.swat.ui.uiRef.showNotification({ message: "No new products to add to Wishlist." });
                        this._hidePopupContainer(this.seriesPopup);
                    }else{
                        this._resolveBatchedPromises(batches, filteredProducts.length);
                    }
                } else
                    alert(`No variants found for ${binding} in ${this.selectedLanguage}.`);
            }
            setTimeout(() => {
                this.swat.collectionsApi.initializeCollections(this.swat, true, window.Shopify.theme.schema_name);
                console.log("Collections reinitialized after adding products to Wishlist.");
            }, 2000);
        }

        _resolveBatchedPromises(batches, itemsCount) {
            // Convert each batch operation to a promise
            const batchPromises = batches.map(batch => {
                return new Promise((resolve, reject) => {
                    this.swat.addProductsToList(
                        this.activeListId,
                        batch,
                        res => resolve(res),
                        err => reject(err)
                    );
                });
            });
            Promise.all(batchPromises)
            .then(results => {
                this.swat.ui.showSuccessNotification({ 
                    message: `${itemsCount} products have been added successfully to the Wishlist.` 
                });
                this._hidePopupContainer(this.seriesPopup);
            })
            .catch(err => {
                // At least one batch failed
                this.swat.ui.uiRef.showErrorNotification({ 
                    message: "Error while adding products to Wishlist" 
                });
                this._hidePopupContainer(this.seriesPopup);
            })
            .finally(() => {
                this.swat.collectionsApi.removeCollectionsButtons();
                this.swat.collectionsApi.initializeCollections(this.swat, true, window.Shopify.theme.schema_name);
            })
        }

        _attachEventListeners(swat){
            let event = 'sw:variantchanged';
            let listener = (eventData) => {
                console.log("Variant Changed:", eventData);
                this.dataset.variantId = eventData.detail.d.currentVariantId;
            };
            swat.evtLayer.addEventListener(event, listener);
            this.addEventListener('click', this._customButtonFunction);
            document.body.addEventListener('click', evt =>this._overlayEvent(evt));
            this.seriesPopupCloseButton.addEventListener('click', evt => this._hidePopupContainer(this.seriesPopup));
            this.bindingButtons.addEventListener('click', evt => this._addSeriestoWishlist(evt));
            this.languageSelect.addEventListener('change', () => {this.selectedLanguage = this.languageSelect.value;});
            this.wishlistSelector.addEventListener('change', (evt) => { this.activeListId = evt.target.value;});
            swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, (evt)=> {this._checkForExistingListsAndRefetchLists(evt.detail.d.lid)});
        }

        _initializeSwymComponent(){
            if (!window.SwymCallbacks) window.SwymCallbacks = [];
            window.SwymCallbacks.push(this._init.bind(this));
        }
    }
    customElements.define('swym-custom-button', SwymCustomButton);
}